export class BeneficiaryDetails_DH{
    public Name: string;
    public Relationship: number;
    public ContactNo: string;
    public EMail: string;
    public BeneficiaryAddress: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/BeneficiaryDetails_DH.ts